// The legacy API has a painful missmatch of strings and integers for this meta
export default [
  {
    label: 'Eyes Tested',
    key: 'eyesTested',
    type: String
  },
  {
    label: 'Elbow Scored',
    key: 'elbow',
    type: Number
  },
  {
    label: 'Hip Scored',
    key: 'hip',
    type: Number
  },
  {
    label: 'Spayed/Neutered',
    key: 'castrated',
    type: Number
  },
  {
    label: 'CEA DNA',
    key: 'cea',
    type: String
  },
  {
    label: 'TNS',
    key: 'tns',
    type: String
  },
  {
    label: 'CN',
    key: 'cn',
    type: String
  },
  {
    label: 'SN',
    key: 'sn',
    type: String
  },
  {
    label: 'IGS',
    key: 'igs',
    type: String
  },
  {
    label: 'MDR1',
    key: 'mdr1',
    type: String
  },
  {
    label: 'NCL',
    key: 'ncl',
    type: String
  }
]
